import React, { useEffect, useState } from "react";
import "./Header.css";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import useHttp from "../hooks/use-http";
import cytLogo from "../img/cyt-logo.png";
import vwcLogo from "../img/vwc-logo.png";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import LogoutIcon from "@mui/icons-material/Logout";
import SettingsIcon from "@mui/icons-material/Settings";
import NavTabs from "./NavTabs";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useNavigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import useStore from "../stores/useStore";
import MenuIcon from "@mui/icons-material/Menu";
import HeaderDrawer from "./HeaderDrawer";
import { useTranslation } from "react-i18next";
import EersteKeerModal from "../modals/EersteKeerModal";

const Header = (props) => {
  const theme = useTheme();
  const { logout } = useAuth0();
  const navigate = useNavigate();
  const {
    user,
    resetRedirectUri,
    languageSaved,
    setLanguageSaved,
    resetUser,
  } = useStore();
  const { t, i18n } = useTranslation();
  // Media queries
  const mobile = useMediaQuery(theme.breakpoints.between("mobile", "ipad"));
  const tablet = useMediaQuery(theme.breakpoints.between("ipad", "laptop"));
  const laptop = useMediaQuery(theme.breakpoints.up("laptop"));

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const {
    sendRequest: logoutUserRequest,
    isLoading: logoutUserLoading,
    error: logoutUserError,
  } = useHttp();

  function logoutUser() {
    function applyData(res) {
      logout({
        logoutParams: { returnTo: window.location.origin },
      });
      resetRedirectUri();
      resetUser();
    }

    logoutUserRequest(
      {
        url: `${process.env.REACT_APP_BACKEND_URL}/auth/logout`,
        method: "POST",
      },
      applyData
    );
  }

  // TABLET
  const [drawerOpen, setDrawerOpen] = React.useState(false);

  const toggleDrawer = (newOpen) => () => {
    setDrawerOpen(newOpen);
  };

  return (
    <React.Fragment>
      {/* MOBILE */}
      {mobile && (
        <div className="m-header-container">
          <HeaderDrawer open={drawerOpen} toggleDrawer={toggleDrawer} />
          <div className="m-header-left">
            <MenuIcon onClick={toggleDrawer(true)} sx={{ cursor: "pointer" }} />
          </div>

          <div className="t-header-mid">
            <img
              className="header-vwc-logo"
              src={i18n.language === "nl" ? vwcLogo : cytLogo}
              alt="company-logo"
              onClick={() => navigate("/")}
            />
          </div>

          <div className="t-header-right">
            <div className="t-h-icons">
              <span className="h-initial" onClick={handleClick}>
                {user?.name?.substring(0, 1) || "?"}
              </span>
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  sx: { 
                    backgroundColor: "#fff",
                    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                    borderRadius: "8px",
                    padding: "8px 0"
                  }
                }}
              >
                <MenuItem 
                  sx={{ 
                    width: "200px", 
                    display: "flex", 
                    alignItems: "center", 
                    gap: "12px",
                    "&:hover": { backgroundColor: "#f5f5f5" }
                  }} 
                  onClick={() => {
                    navigate("/account-settings");
                    handleClose();
                  }}
                >
                  <SettingsIcon sx={{ color: "#439BD9", fontSize: "18px" }} />
                  {t("Accountinstellingen")}
                </MenuItem>
                <MenuItem 
                  sx={{ 
                    width: "200px", 
                    display: "flex", 
                    alignItems: "center", 
                    gap: "12px",
                    "&:hover": { backgroundColor: "#f5f5f5" }
                  }} 
                  onClick={logoutUser}
                >
                  <LogoutIcon sx={{ color: "#439BD9", fontSize: "18px" }} />
                  {t("logout")}
                </MenuItem>
              </Menu>
            </div>
          </div>
        </div>
      )}

      {/* TABLET */}
      {tablet && (
        <div className="t-header-container">
          <HeaderDrawer open={drawerOpen} toggleDrawer={toggleDrawer} />
          <div className="t-header-left">
            <MenuIcon onClick={toggleDrawer(true)} sx={{ cursor: "pointer" }} />
          </div>

          <div className="t-header-mid">
            <img
              className="header-vwc-logo"
              src={i18n.language === "nl" ? vwcLogo : cytLogo}
              alt="company-logo"
              onClick={() => navigate("/")}
            />
          </div>

          <div className="t-header-right">
            <div className="t-h-icons">
              <span className="h-initial">
                {user?.name?.substring(0, 1) || "?"}
              </span>
              <span>{user.name}</span>
              <KeyboardArrowDownIcon
                style={{ cursor: "pointer" }}
                onClick={handleClick}
              />
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
              >
               
                <MenuItem sx={{ width: "200px" }} onClick={logoutUser}>
                  {t("logout")}
                </MenuItem>
                <MenuItem sx={{ width: "200px" }} onClick={() => {
                  navigate("/account-settings");
                  handleClose();
                }}>
                  {t("Accountinstellingen")}
                </MenuItem>
              </Menu>
            </div>
          </div>
        </div>
      )}

      {/* LAPTOP */}
      {laptop && (
        <div className="d-header-container">
          <div className="d-header-left">
            <img
              className="header-vwc-logo"
              src={i18n.language === "nl" ? vwcLogo : cytLogo}
              alt="company-logo"
              onClick={() => navigate("/")}
            />
            <NavTabs />
          </div>

          <div className="d-header-right">
            <EersteKeerModal
              languageSaved={languageSaved}
              setLanguageSaved={setLanguageSaved}
              headerVariant
            />
            <div className="d-h-icons">
              <span className="h-initial" onClick={handleClick}>
                {user?.name?.substring(0, 1) || "?"}
              </span>{" "}
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: -10,
                  horizontal: 'right',
                }}
                MenuListProps={{
                  sx: { 
                    backgroundColor: "#fff",
                    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #dcedfa",
                    borderRadius: "0px",
                    padding: "8px 0",
                  }
                }}
              >
                <MenuItem 
                  sx={{ 
                    width: "200px", 
                    display: "flex", 
                    alignItems: "center", 
                    gap: "12px",
                    "&:hover": { backgroundColor: "#f5f5f5" }
                  }} 
                  onClick={() => {
                    navigate("/account-settings");
                    handleClose();
                  }}
                >
                  <SettingsIcon sx={{ color: "#439BD9", fontSize: "18px" }} />
                  <span style={{ fontSize: "14px" }}>{t("Accountinstellingen")}</span>
                </MenuItem>
                <MenuItem 
                  sx={{ 
                    width: "200px", 
                    display: "flex", 
                    alignItems: "center", 
                    gap: "12px",
                    "&:hover": { backgroundColor: "#f5f5f5" }
                  }} 
                  onClick={logoutUser}
                >
                  <LogoutIcon sx={{ color: "#439BD9", fontSize: "18px" }} />
                  <span style={{ fontSize: "14px" }}>{t("logout")}</span>
                </MenuItem>
              </Menu>
              {/* <span className="header-username">{user.name}</span> */}
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default Header;
